import { render } from "./PlayerActions.vue?vue&type=template&id=1661c2b6&scoped=true"
import script from "./PlayerActions.vue?vue&type=script&lang=js"
export * from "./PlayerActions.vue?vue&type=script&lang=js"

import "./PlayerActions.vue?vue&type=style&index=0&id=1661c2b6&scoped=true&lang=css"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\music_player\\music_player_sj\\music_player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1661c2b6"]])

export default __exports__